<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';
import { watchDebounced } from '@vueuse/core';
import _isEqual from 'lodash/isEqual';

import KNumberField from '@/components/fields/KNumberField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  weight?: number;
}

export interface ValidData {
  weight: number;
}

export interface Props {
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (formData.weight == null) return;
  const validData: ValidData = {
    weight: formData.weight,
  };
  emit('submit', event, validData);
});

watchDebounced(
  [() => formData.weight],
  async (newValues, oldValues) => {
    if (_isEqual(newValues, oldValues)) return;
    await handleSubmit();
  },
  { debounce: 100 },
);
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.newAirRoadChangeWeightDialogForm"
    data-testid="newAirRoadChangeWeightDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KNumberField
      v-model="formData.weight"
      :min="0"
      size="xs"
      clearable
      label="Weight"
      :rules="[requiredValidationRule]"
      :class="$style.field"
      hide-details
      autofocus
    />
    <input type="submit" class="hidden" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadChangeWeightDialogForm {
  font-size: 14px;
}
  .field {
  }
</style>
